import { useMutation } from '@gogame/query';

import { createMediaSource } from 'scenes/Campaigns/sources/campaigns';

import { createMS } from '../queryKeyFactory';

export const useCreateMediaSource = () => {
  const createMutation = useMutation(createMS(), createMediaSource, {
    successMessage: () => 'Created media source',
  });

  return [createMutation.mutateAsync, createMutation];
};
